export default function cutPosterImage(videoEl) {
  if (!videoEl.duration || isNaN(videoEl.duration)) {
    return null;
  }
  const pixelRatio = window.devicePixelRatio || 1;
  const height = videoEl.offsetHeight;
  const width = videoEl.offsetWidth;
  const canvas = document.createElement("canvas");
  canvas.height = height * pixelRatio;
  canvas.width = width * pixelRatio;

  const context = canvas.getContext("2d");
  context.scale(pixelRatio, pixelRatio);
  context.drawImage(videoEl, 0, 0, width, height);
  const data = context.canvas.toDataURL("image/png");
  return data;
}
